import { AppointmentState } from './reducer';

export const getList = (state: AppointmentState) => state.appointments;

export const getShouldLoad = (state: AppointmentState) =>
    state.countTotal == null || state.countTotal > state.appointments.length;

export const getActiveListItem = (state: AppointmentState) => state.activeListItem;
